(function () {
  'use strict';

  const root =
    (window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root) ||
    '/';

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  async function getCart() {
    const response = await fetch(root + 'cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Could not load cart');
    }

    return response.json();
  }

  async function changeCartItem(key, quantity) {
    const response = await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    });

    if (!response.ok) {
      let message = 'Could not update cart.';

      try {
        const data = await response.json();
        message = data.description || data.message || message;
      } catch (e) {}

      throw new Error(message);
    }

    return response.json();
  }

  function setCartBusy(line, isBusy) {
    if (!line) return;

    line.classList.toggle('is-updating', isBusy);

    line.querySelectorAll('button,input,a').forEach(function (control) {
      if ('disabled' in control) {
        control.disabled = isBusy;
      }

      control.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    });
  }

  function setCartStatus(message, isError) {
    const status = document.querySelector('[data-cart-status]');

    if (!status) return;

    status.textContent = message || '';
    status.classList.toggle('error', !!isError);
  }

  async function updateCartLine(line, quantity) {
    if (!line || line.classList.contains('is-updating')) return;

    const key = line.dataset.key;
    if (!key) return;

    const requestedQuantity = parseInt(quantity, 10);
    const nextQuantity = isNaN(requestedQuantity)
      ? 1
      : Math.min(1, Math.max(0, requestedQuantity));

    setCartBusy(line, true);
    setCartStatus('Updating cart…', false);

    try {
      const cart = await changeCartItem(key, nextQuantity);
      setCartCount(cart.item_count);

      // Preserve server-rendered prices for currency conversion.
      window.location.reload();
    } catch (error) {
      setCartStatus(error.message || 'Could not update cart.', true);

      try {
        const cart = await getCart();
        setCartCount(cart.item_count);

        const item = cart.items.find(function (cartItem) {
          return cartItem.key === key;
        });

        const input = line.querySelector('[data-cart-quantity]');

        if (input && item) {
          input.value = item.quantity;
        }
      } catch (e) {}

      setCartBusy(line, false);
    }
  }

  function initCartPage() {
    const cartPage = document.querySelector('[data-cart-page]');

    if (!cartPage || cartPage.dataset.cartInitialized === 'true') return;

    cartPage.dataset.cartInitialized = 'true';

    cartPage.addEventListener('click', function (event) {
      const minus = event.target.closest('[data-cart-qty-minus]');
      const plus = event.target.closest('[data-cart-qty-plus]');
      const remove = event.target.closest('[data-cart-remove]');
      const line = event.target.closest('[data-cart-line]');

      if (!line) return;

      const input = line.querySelector('[data-cart-quantity]');

      if (minus && input) {
        event.preventDefault();

        const next = Math.max(
          0,
          (parseInt(input.value, 10) || 0) - 1
        );

        input.value = next;
        updateCartLine(line, next);
        return;
      }

      if (plus && input) {
        event.preventDefault();

        input.value = 1;
        setCartStatus('Only one piece is available per saree.', false);
        return;
      }

      if (remove) {
        event.preventDefault();
        updateCartLine(line, 0);
      }
    });

    let timer;

    cartPage.addEventListener('input', function (event) {
      if (!event.target.matches('[data-cart-quantity]')) return;

      const input = event.target;
      const line = input.closest('[data-cart-line]');

      clearTimeout(timer);

      timer = setTimeout(function () {
        updateCartLine(line, input.value);
      }, 450);
    });
  }

  function showViewCart(status) {
    if (!status) return;

    status.replaceChildren();
    status.classList.remove('error');

    const message = document.createElement('span');
    message.textContent = 'Added to cart successfully.';

    const viewCart = document.createElement('a');
    viewCart.href = root + 'cart';
    viewCart.className = 'btn btn-dark';
    viewCart.textContent = 'View Cart';
    viewCart.style.display = 'inline-flex';
    viewCart.style.marginTop = '12px';

    const buttonWrap = document.createElement('span');
    buttonWrap.style.display = 'block';
    buttonWrap.appendChild(viewCart);

    status.appendChild(message);
    status.appendChild(buttonWrap);
  }

  function initProductForm() {
    document.querySelectorAll('[data-product-root]').forEach(function (rootEl) {
      if (rootEl.dataset.productInitialized === 'true') return;

      rootEl.dataset.productInitialized = 'true';

      const variantsScript = rootEl.querySelector('[data-product-variants]');
      let variants = [];

      try {
        variants = JSON.parse(
          variantsScript ? variantsScript.textContent : '[]'
        );
      } catch (e) {}

      const variantSelect = rootEl.querySelector('[data-variant-select]');
      const addButton = rootEl.querySelector('[data-add-to-cart]');
      const form = rootEl.querySelector('[data-ajax-product-form]');
      const status = rootEl.querySelector('[data-product-form-status]');
      const quantity = rootEl.querySelector(
        '[data-product-quantity], input[name="quantity"]'
      );

      let isAdding = false;
      let resetTimer;

      function selectedVariant() {
        if (!variantSelect) return variants[0];

        return variants.find(function (variant) {
          return String(variant.id) === String(variantSelect.value);
        });
      }

      function refreshProductState() {
        const variant = selectedVariant();

        if (!variant) return;

        // Leave Liquid-rendered prices intact for Nova.
        if (addButton) {
          addButton.disabled = isAdding || !variant.available;
          addButton.textContent = isAdding
            ? 'Adding…'
            : variant.available
              ? 'Add to Cart'
              : 'Sold Out';
        }

        const stockNote = rootEl.querySelector('[id^="StockNote-"]');

        if (stockNote) {
          stockNote.textContent = variant.available
            ? 'Only 1 piece available — a limited saree.'
            : 'This limited piece is sold out.';
        }
      }

      if (variantSelect && variantSelect.tagName === 'SELECT') {
        variantSelect.addEventListener('change', function () {
          const productUrl = new URL(window.location.href);
          productUrl.searchParams.set('variant', variantSelect.value);
          window.location.assign(productUrl.toString());
        });
      }

      if (quantity) {
        quantity.value = 1;
        quantity.min = 1;
        quantity.max = 1;
        quantity.readOnly = true;
      }

      rootEl.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (quantity) quantity.value = 1;
        });
      });

      rootEl.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (quantity) quantity.value = 1;
        });
      });

      if (form) {
        form.addEventListener('submit', async function (event) {
          event.preventDefault();

          if (isAdding || (addButton && addButton.disabled)) return;

          clearTimeout(resetTimer);
          isAdding = true;

          if (quantity) quantity.value = 1;
          refreshProductState();

          if (status) {
            status.textContent = '';
            status.classList.remove('error');
          }

          try {
            const formData = new FormData(form);
            formData.set('quantity', '1');

            const response = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json'
              },
              body: formData
            });

            if (!response.ok) {
              let message = 'Could not add this product.';

              try {
                const data = await response.json();
                message = data.description || data.message || message;
              } catch (e) {}

              throw new Error(message);
            }

            showViewCart(status);

            try {
              const cart = await getCart();
              setCartCount(cart.item_count);
            } catch (e) {}

            if (addButton) {
              addButton.textContent = 'Added ✓';
            }

            resetTimer = setTimeout(function () {
              isAdding = false;
              refreshProductState();
            }, 1100);
          } catch (error) {
            isAdding = false;

            if (status) {
              status.textContent =
                error.message || 'Could not add this product.';
              status.classList.add('error');
            }

            refreshProductState();
          }
        });
      }

      refreshProductState();
    });
  }

  function initializeTheme() {
    document.querySelectorAll('[data-country-selector]').forEach(function (select) {
      if (select.dataset.countryInitialized === 'true') return;

      select.dataset.countryInitialized = 'true';

      select.addEventListener('change', function () {
        if (select.form) {
          select.form.submit();
        }
      });
    });

    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');

    if (toggle && menu && toggle.dataset.menuInitialized !== 'true') {
      toggle.dataset.menuInitialized = 'true';

      toggle.addEventListener('click', function () {
        const open = menu.classList.toggle('open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }

    initProductForm();
    initCartPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTheme);
  } else {
    initializeTheme();
  }

  document.addEventListener('shopify:section:load', initializeTheme);
})();

// Collection sorting: preserve active filters.
(function () {
  'use strict';

  function initCollectionSorting() {
    const form = document.getElementById('CollectionFiltersForm');
    const sort = document.querySelector('[data-collection-sort]');

    if (!form || !sort || sort.dataset.sortInitialized === 'true') return;

    sort.dataset.sortInitialized = 'true';

    sort.addEventListener('change', function () {
      form.submit();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionSorting);
  } else {
    initCollectionSorting();
  }

  document.addEventListener('shopify:section:load', initCollectionSorting);
})();

// Our Story reveal and gentle parallax.
(function () {
  'use strict';

  function initOurStory() {
    const section = document.querySelector('[data-our-story]');

    if (!section || section.dataset.storyInitialized === 'true') return;

    section.dataset.storyInitialized = 'true';

    const revealItems = section.querySelectorAll('[data-story-reveal]');
    const art = section.querySelector('[data-story-parallax]');

    const reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    } else {
      const observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    }

    if (!art || reduceMotion) return;

    let ticking = false;

    function updateParallax() {
      ticking = false;

      const rect = section.getBoundingClientRect();
      const viewport =
        window.innerHeight ||
        document.documentElement.clientHeight;

      if (rect.bottom < 0 || rect.top > viewport) return;

      let progress =
        (viewport - rect.top) /
        (viewport + rect.height);

      progress = Math.max(0, Math.min(1, progress));

      const offset = (progress - 0.5) * 22;

      art.style.setProperty(
        '--story-parallax',
        offset.toFixed(2) + 'px'
      );
    }

    function requestParallax() {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(updateParallax);
    }

    updateParallax();

    window.addEventListener('scroll', requestParallax, {
      passive: true
    });

    window.addEventListener('resize', requestParallax);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOurStory);
  } else {
    initOurStory();
  }
})();

// Display converted prices with a decimal point.
// OMR keeps three decimal places; other prices keep two.
(function () {
  'use strict';

  if (window.ekaDecimalDisplayInitialized) return;
  window.ekaDecimalDisplayInitialized = true;

  function formatPriceText(text, currencyContext) {
    const isOMR = /\bOMR\b/i.test(currencyContext || text);

    const pattern = isOMR
      ? /(^|[^\d.,])(\d+(?:\.\d{3})*),(\d{3})(?![\d.,])/g
      : /(^|[^\d.,])(\d+(?:\.\d{3})*),(\d{2})(?![\d.,])/g;

    return text.replace(
      pattern,
      function (match, prefix, whole, decimals) {
        return (
          prefix +
          whole.replace(/\./g, ',') +
          '.' +
          decimals
        );
      }
    );
  }

  function updateMoneyElement(element) {
    // Read the whole price so OMR is detected even in a separate child span.
    const currencyContext = element.textContent;

    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT
    );

    let node;

    while ((node = walker.nextNode())) {
      const current = node.nodeValue;
      const formatted = formatPriceText(current, currencyContext);

      if (formatted !== current) {
        node.nodeValue = formatted;
      }
    }
  }

  function startPriceFormatting() {
    const pending = new Set();
    let scheduled = false;

    function queueMoney(element) {
      if (!element || element.nodeType !== 1) return;

      const parentMoney = element.closest('.money');

      if (parentMoney) {
        pending.add(parentMoney);
      }

      element.querySelectorAll('.money').forEach(function (money) {
        pending.add(money);
      });

      if (scheduled || pending.size === 0) return;

      scheduled = true;

      window.requestAnimationFrame(function () {
        scheduled = false;

        pending.forEach(function (money) {
          if (money.isConnected) {
            updateMoneyElement(money);
          }
        });

        pending.clear();
      });
    }

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          queueMoney(mutation.target.parentElement);
          return;
        }

        queueMoney(mutation.target);

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            queueMoney(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });

    queueMoney(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startPriceFormatting,
      { once: true }
    );
  } else {
    startPriceFormatting();
  }
})();